FamilycardsImageLibrary.controller('editImageController', [ '$scope', '$http', '$timeout', 'Upload', function( $scope, $http, $timeout ,Upload ) {

	$scope.editImageForm = {
		formats: {},
		effects: {}
	};

	$scope.pictureId = false;
	$scope.variations = {};
	$scope.effects = {};
	$scope.impression = {};

	$http({
		method: 'GET',
		url: api_url_variations,
	}).
	success( function( data, status, headers, config ) {
		$scope.variations = data;
		$timeout(function() {
			initPopup();
		});
	}).
	error(function(data, status, headers, config) {});

	$scope.$watch(function () {
		return {
			effects: $scope.effects
		}
	}, function (newFilters, oldFilters) {

		if( newFilters == oldFilters ) {
			return;
		}

		if( newFilters.effects ) {
			calculateEffectVariations( newFilters.effects );
		}

	}, true);

	$scope.uploadVariationImage = function(file, errFiles, variation) {

        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];

        if (file) {

        	variation.is_uploading = true;

            file.upload = Upload.upload({
                url: api_url_upload_variation,
                data: {
                	image: file,
                	format: variation.sub_format_id,
                	effect: variation.effect_id
                }
            });

            file.upload.then(function (response) {
            	$timeout(function() {
					initPopup();
				});
            	variation.is_uploading = false;
                variation.file_name = response.data.name;
                variation.file_link = response.data.file_url;
            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        } 
    }

    $scope.uploadImpressionImage = function(file, errFiles) {

        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];

        if (file) {

        	$scope.impression.is_uploading = true;

            file.upload = Upload.upload({
                url: api_url_upload_impression,
                data: {
                	image: file,
                	impression: true,
                }
            });

            file.upload.then(function (response) {
            	$timeout(function() {
					initPopup();
				});
            	$scope.impression.is_uploading = false;
            	$scope.impression.file_name = response.data.file_name;
            	$scope.impression.url = response.data.file_url;

            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        } 
    }

    $scope.setSelectValue = function( $value ) {
		$scope.editImageForm.pictureType = $value;
	}

	$scope.setEffectCheckboxValue = function( $effect ) {
		$scope.effects[$effect] = true;
	}

	$scope.setCheckboxTrueValue = function( $fieldset, $field ) {
		$scope.editImageForm[$fieldset][$field] = true;
	}

	$scope.setImpression = function( $url, $filename ) {
		$scope.impression = {
			url: $url,
			file_name: $filename
		}
	}

	$scope.deleteImpression = function( impression ) {
		var r = confirm("Weet je zeker dat je deze impressie wilt verwijderen?");
		if (r == true) {
		   
			impression.is_deleting = true;

			$http({
				method: 'GET',
				url: api_url_delete_impression,
			}).
			success( function( data, status, headers, config ) {
				if( data == true ) {
					impression.is_deleting = false;
					impression.file_name = false;
				}
			}).
			error(function(data, status, headers, config) {});

		}

	}

	$scope.deleteVariation = function( variation ) {

		var r = confirm("Weet je zeker dat je deze variatie wilt verwijderen?");
		if (r == true) {
		
			variation.is_deleting = true;
			variation.file_name = false;

			$http({
				method: 'POST',
				url: api_url_delete_variation,
				data: {
					format_id: variation.sub_format_id,
	                effect_id: variation.effect_id

				}
			}).
			success( function( data, status, headers, config ) {
				if( data == true ) {
					variation.file_link = false;
					variation.is_deleting = false;
				}
			}).
			error(function(data, status, headers, config) {});

		}

	}

	var calculateEffectVariations = function( newEffects ) {

		for(var variationKey in $scope.variations ) {

			if( $scope.variations[variationKey].is_active ) {

				for(var effectKey in newEffects) {

					var subformatId = $scope.variations[variationKey].sub_format_id;

					if( newEffects[effectKey] ) {
						$scope.variations['format_' +  subformatId + '_' + effectKey].is_active = true;
					} else {
						$scope.variations['format_' +  subformatId + '_' + effectKey].is_active = false;
					}

				}

			}

		}

	}

}]);